import { theme as sharedTheme } from '@bottlebooks/gatsby-shared';
import { theme as baseTheme } from '@bottlebooks/gatsby-theme-base';

const theme = {
  ...baseTheme,
  ...sharedTheme,
};

export default theme;
